export const WebStorageFilterOptionsKeys = {
  ADMIN_AUDIT_LOG_FILTER_OPTIONS: 'ADMIN_AUDIT_LOG_FILTER_OPTIONS',
  APPROVE_VIEW_FILTER_OPTIONS: 'APPROVE_VIEW_FILTER_OPTIONS',
  IIN_VIEW_FILTER_OPTIONS: 'IIN_VIEW_FILTER_OPTIONS',
  INVESTIGATE_VIEW_FILTER_OPTIONS: 'INVESTIGATE_VIEW_FILTER_OPTIONS',
  MERCHANTS_VIEW_FILTER_OPTIONS: 'MERCHANTS_VIEW_FILTER_OPTIONS',
  TRANSACTIONS_VIEW_FILTER_OPTIONS: 'TRANSACTIONS_VIEW_FILTER_OPTIONS',
  USER_ACCOUNTS_VIEW_FILTER_OPTIONS: 'USER_ACCOUNTS_VIEW_FILTER_OPTIONS',
} as const;

export type WebStorageFilterOptionsKeyValue =
  (typeof WebStorageFilterOptionsKeys)[keyof typeof WebStorageFilterOptionsKeys];

/**
 *  This data will be cleared on user logout
 */
export const WebStorageUserSessionKeys = {
  ...WebStorageFilterOptionsKeys,

  // Rules hub
  RULESETS_WORKFLOW_ALL_RULESETS_COLUMNS_VISIBILITY: 'RULESETS_WORKFLOW_ALL_RULESETS_COLUMNS_VISIBILITY',
  RULESETS_WORKFLOW_ALL_RULESETS_FILTERS: 'RULESETS_WORKFLOW_ALL_RULESETS_FILTERS',
} as const;

/**
 * All the web storage keys
 */
export const WebStorageKeys = {
  ...WebStorageUserSessionKeys,

  PAYMENTIQ_GENERAL_SETTINGS: 'PAYMENTIQ_GENERAL_SETTINGS',
  PAYMENTIQ: 'PaymentIQ', // TODO: remove this key when get rid of the legacy code that uses it
} as const;
